import { ResendEmail } from './ResendEmail/ResendEmail';
import { store } from '@/config/store';
import { getAffiliateIdFromThemeId } from '@/utils/shop';

export const ResendEmailPage = () => {
  const themeId = store.state.themeId;
  return <ResendEmail affiliateId={getAffiliateIdFromThemeId(themeId)} />;
};
